// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__MPX3w","label":"Completed_label__1bMtA"};